import { render, staticRenderFns } from "./PagePart1.vue?vue&type=template&id=475e6430&scoped=true"
import script from "./PagePart1.vue?vue&type=script&lang=js"
export * from "./PagePart1.vue?vue&type=script&lang=js"
import style0 from "./PagePart1.vue?vue&type=style&index=0&id=475e6430&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e6430",
  null
  
)

export default component.exports